/**
 * @todo Удалить директорию
 * @description Данный функционал появился в задаче CD-162876, будет удалён в задаче CD-193764
 */

import { ca } from '@cian/analytics';

import { FC } from 'react';

import { useListingContext } from 'shared/context/ListingContext';
import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import { ToLegacyListing } from './ToLegacyListing';

export const ToLegacyListingContainer: FC = () => {
  const {
    listingProperties: { urlToLegacyListing },
  } = useListingContext();
  const isShortListing = useListingLayoutIsShortSelector();

  if (isShortListing || !urlToLegacyListing) {
    return null;
  }

  const trackLinkClick: VoidFunction = () => {
    ca('eventSite', {
      action: 'click_sopr',
      category: 'Listing',
      label: 'old_listing_view',
      name: 'oldevent',
    });
  };

  const handleClick: VoidFunction = () => {
    document.cookie = 'declined_from_new_commercial_listing=1;domain=.cian.ru;path=/';
  };

  if (!urlToLegacyListing) {
    return null;
  }

  return <ToLegacyListing trackLinkClick={trackLinkClick} url={urlToLegacyListing} onClick={handleClick} />;
};
